import Reading from "spectral-core/models/Reading";

export const NO_APPLICATION_LABEL = "—";

export function applicationLabel(reading: Reading): string {
  return (reading.type || "").trim() || NO_APPLICATION_LABEL;
}

export interface DashboardOverview {
  totalReadings: number;
  lastSync: Date | null;
  avgTemperature: number | null;
  byMonth: Record<string, number>;
  byApplication: Record<string, number>;
}

function parseReadingDate(reading: Reading): Date | null {
  if (!reading.dateTime) return null;
  const d = new Date(reading.dateTime);
  return isNaN(d.getTime()) ? null : d;
}

export function aggregateDashboardOverview(readings: Reading[]): DashboardOverview {
  let lastSync: Date | null = null;
  let tempSum = 0;
  let tempN = 0;
  const byMonth: Record<string, number> = {};
  const byApplication: Record<string, number> = {};

  for (const r of readings) {
    if (r.syncedToCloudAt) {
      const d = new Date(r.syncedToCloudAt);
      if (!isNaN(d.getTime()) && (!lastSync || d > lastSync)) lastSync = d;
    }
    if (typeof r.temperature === "number" && !isNaN(r.temperature)) {
      tempSum += r.temperature;
      tempN++;
    }
    const dt = parseReadingDate(r);
    if (dt) {
      const key = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}`;
      byMonth[key] = (byMonth[key] || 0) + 1;
    }
    const app = applicationLabel(r);
    byApplication[app] = (byApplication[app] || 0) + 1;
  }

  return {
    totalReadings: readings.length,
    lastSync,
    avgTemperature: tempN ? tempSum / tempN : null,
    byMonth,
    byApplication,
  };
}
